import React from 'react';
import { Link } from 'react-router-dom';
import ImageLoader from './ImageLoader';
import { useTranslation } from 'react-i18next';
const DataNotFound = ({ message, link = false }) => {
  const { t } = useTranslation('common');
  return (
    <>
      <div className="mb-6">
        <div className="mx-auto text-center">
          <ImageLoader
            src="/img/performedanytransaction.png"
            className="inline-block mb-4 max-w-[180px]"
            alt=""
          />
        </div>
        <div className="text-center text-xl font-semibold text-brandBlue dark:text-slate-200 mb-3">
          {message || 'NA'}
        </div>
        {link && (
          <div className="text-center">
            <Link to="/assets">
              <button className="bg-[#A7D760] text-[#0B243F] text-md font-semibold rounded-md px-5 leading-normal py-2 flex-inline flex-col justify-center items-center hover:bg-[#97C05B] focus:bg-[#A7D760] active:bg-[#8DB158] hover:transition-all mt-12">
                {t('explore_projects')}
              </button>
            </Link>
          </div>
        )}
      </div>
    </>
  );
};

export default DataNotFound;
